import type { FC } from 'react'

import './address.scss'

const Address: FC<{
  street1?: string
  street2?: string
  zip?: string
  city?: string
  country?: string
}> = ({ street1, street2, zip, city, country }) => (
  <address className="address">
    {street1 && <>{street1}</>}

    {street2 && (
      <>
        {street1 && <br />}
        {street2}
      </>
    )}

    {(zip || city) && (
      <>
        {(street1 || street2) && <br />}
        {zip}, {city}
      </>
    )}

    {country && (
      <>
        {(street1 || street2 || zip || city) && <br />}
        {country}
      </>
    )}
  </address>
)

export default Address
